const TIPOS_ACOMPANANTE = {
  PROGENITOR: 'PRO',
  TERCERO: 'TER',
}

const TIPOS_SOLICITUD = {
  AUTORIZACION: 'AUT',
  REVOCATORIA: 'REV',
  REVOCATORIA_TOTAL: 'RVT',
}

const ESTADOS_SOLICITUD = {
  REVOCATORIA_TOTAL_PENDIENTE: 'RTP',
  REVOCATORIA_TOTAL_VERIFICADA: 'RTV',
  PENDIENTE_DE_PRESENTACION: 'PPR',
  SOLICITUD_GENERAL_CREADA: 'SGC',
  SOLICITUD_GENERAL_AUTORIZADA: 'SGA',
}



// lo defino afuera de TIPOS_SOLICITUD porque la API va a transparentear modificatoria y autorizacion como lo mismo
const TIPO_SOLICITUD_MODIFICATORIA = 'MOD'

const formatDate = fecha => new Date(fecha).toISOString()

const isEditable = solicitud =>
  [TIPOS_SOLICITUD.AUTORIZACION, TIPO_SOLICITUD_MODIFICATORIA].includes(
    solicitud.tipo.tipoSolicitudId,
  )

const isFilterable = tipoSolicitud => Object.values(TIPOS_SOLICITUD).includes(tipoSolicitud.id)

export {
  TIPOS_ACOMPANANTE,
  TIPOS_SOLICITUD,
  formatDate,
  isEditable,
  isFilterable,
  ESTADOS_SOLICITUD,
}
